import {getAYDictByTableCodeApi, sendCaptchaApi} from "./api";

export default {
  //  时间戳转日期
  getDate(time){
      console.log(time)
      let _date = new Date(time)
      console.log(_date)
      var y = _date.getFullYear();

      var m = _date.getMonth()+1;
    if(m<10) m="0"+m
      var d = _date.getDate();
    if(d<10) d="0"+d
      return y+'-'+m+'-'+d;
  },
  //时间戳转日期带时间
  getDateWithTime(){
    console.log('getDateWithTime')
  },
  //  时间戳转日期
  getAttachId(arr){
    let idList = []
    arr.forEach((item)=>{
      idList.push(item.attachId)
    })
    return idList
  },
  setDiseaseData(arr){
    let reArr = []
    arr.forEach(item=>{
      let _dissArr = []
      for(let i=0;i<item.diseasesId.length;i+=2){
        if(i==0){
          _dissArr.push(item.diseasesId.substring(i,i+2)+'00')
        }else if(i==2){
          _dissArr.push(item.diseasesId.substring(0,2)+item.diseasesId.substring(i,i+2))
        }else{
          _dissArr.push(_dissArr[_dissArr.length-1]+item.diseasesId.substring(i,i+2))
        }
      }
      reArr.push(_dissArr)
    })
    return reArr
  },
  //获取字典
  getDics(code)
  {
    getAYDictByTableCodeApi({tableCode:code}).then(res => {
      if (res.msgCode == 200) {
        console.log(res.responseData)
        return  res.responseData
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  //金额格式化 19,500,00.00
	dealThousands(value, type){
		if (value === 0) {
			return parseFloat(value).toFixed(2);
		}
		if (value != "") {
			var num = "";
			value += ""; //转化成字符串
			if (type == 1) {
				value = parseFloat(value.replace(/,/g, '')).toFixed(2); //若需要其他小数精度，可将2改成变量
			} else {
				value = parseFloat(value.replace(/,/g, '')).toFixed(0)
			}

			if (value.indexOf(".") == -1) {
				num = value.replace(/\d{1,3}(?=(\d{3})+$)/g, function(s) {
					return s + ',';
				});
			} else {
				num = value.replace(/(\d)(?=(\d{3})+\.)/g, function(s) {
					return s + ',';
				});
			}
		} else {
			num = ""
		}
		return num;
	},
  digitUppercase (n = 0) {
    var fraction = ['角', '分'];
    var digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元');
  }
}



// WEBPACK FOOTER //
// ./src/util/utils.js